import React, { Dispatch } from 'react';
import { State } from './reducer';

export const StateContext = React.createContext<State>(null as any);

export const DispatchContext = React.createContext<Dispatch<any>>(null as any);
